import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as AOS from 'aos';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'HuiosPay';
  cookie_name: any = '';
  all_cookies: any;
  isCookiesAccept: boolean = false;

  constructor(private cookieService: CookieService) {}

  /**method that save cookies by receiving the cookies number and save the name */
  setCookie(name?: any) {
    switch (name) {
      // Case 1
      case 1: {
        this.cookie_name = 'Necessary Cookies';
        this.cookieService.set('Cookies_1', this.cookie_name);
        break;
      }

      // Case 2
      case 2: {
        this.cookie_name = 'Google Marketing Platform';
        this.cookieService.set('Cookies_2', this.cookie_name);
        break;
      }

      // Case 3
      case 3: {
        this.cookie_name = 'Performance Cookies';
        this.cookieService.set('Cookies_3', this.cookie_name);
        break;
      }

      // Case 4
      case 4: {
        this.cookie_name = 'Analytics Cookies';
        this.cookieService.set('Cookies_4', this.cookie_name);
        break;
      }
      // Case 5
      case 5: {
        this.cookie_name = 'Functional Cookies';
        this.cookieService.set('Cookies_5', this.cookie_name);
        break;
      }
      // Case 5
      case 6: {
        this.cookie_name = 'Cookies Policy Note';
        this.cookieService.set('Cookies_6', this.cookie_name);
        break;
      }

      // Default Case
      default: {
        this.cookie_name = 'Cookies Decline';
        this.cookieService.set('Cookies_7', this.cookie_name);
        break;
      }
    }

    // this.cookieService.set('name', name);
    const dateNow = new Date(); //set cookies expiration date
    dateNow.setHours(dateNow.getHours() + 15);
    this.cookieService.set('isCookieSet', 'true', dateNow);
    // console.log('hello2' ,this.cookieService.getAll());
    this.isCookiesAccept = true;
  }

  /**method that delete a single cookies by receiving the cookies number */
  deleteCookie(name: any) {
    // this.cookieService.delete('name');
    switch (name) {
      // Case 1
      case 1: {
        this.cookieService.delete('Cookies_1');
        break;
      }

      // Case 2
      case 2: {
        this.cookieService.delete('Cookies_2');
        break;
      }

      // Case 3
      case 3: {
        this.cookieService.delete('Cookies_3');
        break;
      }

      // Case 4
      case 4: {
        this.cookieService.delete('Cookies_4');
        break;
      }
      // Case 5
      case 5: {
        this.cookieService.delete('Cookies_5');
        break;
      }

      // Default Case
      default: {
        this.cookieService.delete('Cookies_6');
        break;
      }
    }
    const dateNow = new Date(); //set cookies expiration date
    dateNow.setHours(dateNow.getHours());
    this.cookieService.set('isCookieSet', 'false', dateNow);
  }

  deleteAll() {
    this.cookieService.deleteAll();
  }

  saveCookiesSettings(event: any) {
    this.deleteAll();
    // console.log('working', this.isCookiesAccept);
    if (!this.isCookiesAccept) {
      this.setCookie(event);
      this.isCookiesAccept = true;
      // console.log('working two', this.isCookiesAccept);
    }
    //this.isCookiesAccept = false;
  }

  check(event: any, value: any) {
    // console.log('event', event.target.checked);
    if (event.target.checked) {
      this.setCookie(value);
    } else if (!event.target.checked) {
      this.deleteCookie(value);
    }
  }

  checkCookies() {
    this.cookie_name = this.cookieService.getAll();
    if (Object.keys(this.cookie_name).length === 0) {
      return this.isCookiesAccept = false;
    }
    if (this.cookie_name.Cookies_7 === 'Cookies Decline') {
      return this.isCookiesAccept = false;
    }
    if (this.cookie_name.Cookies_1 === 'Necessary Cookies') {
      // this.deleteAll();
      // this.setCookie(1)
      console.log('result 3', this.cookie_name);
      this.isCookiesAccept = true;
    }

    console.log('state', this.isCookiesAccept);
    return this.isCookiesAccept = true;
  }

  ngOnInit(): void {
    AOS.init();
    // AOS.init({disable: 'mobile'});//AOS - 2
    AOS.refresh(); //refresh method is called on window resize and so on, as it doesn't require to build new store with AOS elements and should be as light as possible.

    // this.cookie_name = this.cookieService.get('Cookies_6'); //check if cookies exist
    //this.all_cookies = this.cookieService.getAll();  // get all cookies object if cookie exist

    this.checkCookies();
  }
}
